// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { ActivityLogViewModel } from './activitylogview-model';


export class StudentStoredActivityViewModel {
    studentId: string = null;
	storedActivity: ActivityLogViewModel[] = null;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        
	}
}